const ANALYTICS_BASE = '/SRS/Analytics';
export const ANALYTIC_END_POINTS = {
  Facets: (resultId: number) => `${ANALYTICS_BASE}/Categorical/${resultId}/Facets`,
  FacetsHierarchy: (resultId: number) => `${ANALYTICS_BASE}/Categorical/${resultId}/FacetsHierarchy`,
  Graph: (resultId: number) => `${ANALYTICS_BASE}/Categorical/${resultId}/Graph`,
  TextClusters: (resultId: number) => `${ANALYTICS_BASE}/Text/${resultId}/Clusters`,
  PathHierarchy: (resultId: number) => `${ANALYTICS_BASE}/Categorical/${resultId}/PathHierarchy`,
  ParallelCoordinates: (resultId: number) => `${ANALYTICS_BASE}/Categorical/${resultId}/ParallelCoordinates`,
  PropertyHierarchy: (resultId: number) => `${ANALYTICS_BASE}/Categorical/${resultId}/PropertyHierarchy`,
  Clusters: (resultId: number) => `${ANALYTICS_BASE}/Geospatial/${resultId}/Clusters`,
  GeoJSON: (resultId: number) => `${ANALYTICS_BASE}/Geospatial/${resultId}/GeoJSON`,
  Timeline: (resultId: number) => `${ANALYTICS_BASE}/Temporal/${resultId}/Timeline`,
  FindTFIDF: (resultId: number) => `${ANALYTICS_BASE}/TFIDF/${resultId}/Find`,
  FilterTFIDF: (resultId: number) => `${ANALYTICS_BASE}/TFIDF/${resultId}/Filter`,
};

const DATA_ADAPTERS_BASE = '/SRS/DataAdapters';
export const DATA_ADAPTER_END_POINTS = {
  Login: (id: number) => `${DATA_ADAPTERS_BASE}/${id}/Login`,
  GetDataAdapters: DATA_ADAPTERS_BASE,
  GetDefinitionsById: (id: number) => `${DATA_ADAPTERS_BASE}/${id}/Definitions`,
  GetDefinitions: `${DATA_ADAPTERS_BASE}/Definitions`,
  Query: `${DATA_ADAPTERS_BASE}/Query`,
};

const DOCUMENTS_BASE = '/SRS/Documents';
export const DOCUMENT_END_POINTS = {
  GetDocumentById: (documentId: number) => `${DOCUMENTS_BASE}/${documentId}`,
  GetDocumentByExternalId: (dilId: number, dilDefinitionId: number, externalId: number) =>
    `${DOCUMENTS_BASE}/${dilId}/${dilDefinitionId}/${externalId}`,
};

const EXPORTS_BASE = '/SRS/Export';
export const EXPORT_END_POINTS = {
  GetExportById: (exportId: number) => `${EXPORTS_BASE}/${exportId}`,
  GetStatusById: (exportId: number) => `${EXPORTS_BASE}/${exportId}/Status`,
};

const RESULTS_BASE = '/SRS/Results';
export const RESULT_END_POINTS = {
  GetResultsById: (resultId: number) => `${RESULTS_BASE}/${resultId}`,
  DeleteResultById: (resultId: number) => `${RESULTS_BASE}/${resultId}`,
  Values: (resultId: number) => `${RESULTS_BASE}/${resultId}/Values`,
  Filter: (resultId: number) => `${RESULTS_BASE}/${resultId}/Filter`,
  Export: (resultId: number) => `${RESULTS_BASE}/${resultId}/Export`,
};

const SESSIONS_BASE = '/SRS/Sessions';
export const SESSION_END_POINTS = {
  AllowsAnonymous: `${SESSIONS_BASE}/AllowsAnonymous`,
  Login: `${SESSIONS_BASE}/Authenticate`,
  Logout: `${SESSIONS_BASE}/Logout`,
  Current: `${SESSIONS_BASE}/Current`,
  MultiFactorAuthenticate: `${SESSIONS_BASE}/Authenticate2`,
  AuthenticateToken: `${SESSIONS_BASE}/AuthenticateToken`,
};

const MISCELLANEOUS_BASE = '/SRS';
export const MISCELLANEOUS_END_POINTS = {
  Encrypt: (input: string) => `${MISCELLANEOUS_BASE}/Encrypt/${input}`,
  Plugins: `${MISCELLANEOUS_BASE}/Plugins`,
  Status: `${MISCELLANEOUS_BASE}/Status`,
};
